import { useQuery } from '@tanstack/react-query';
import { StrandedInventoryResponse } from '@sourcito/schemas';
import { apiFetch } from './api';

export const INVENTORY_QUERY_KEYS = {
  stranded: () => ['inventory', 'stranded'] as const,
} as const;

/**
 * Stranded inventory tracking (2026-08-31) — paid-for inventory invisible
 * to the selling flow (unlisted lots with idle stock, PO lines billed but
 * never received). docs/plans/2026-08-31-stranded-inventory-tracking.md.
 * Same api-client / useQuery convention as useDashboard (lib/dashboard.ts).
 */
export function useStrandedInventory(enabled = true) {
  return useQuery({
    queryKey: INVENTORY_QUERY_KEYS.stranded(),
    enabled,
    queryFn: () =>
      apiFetch('/api/inventory/stranded', { responseSchema: StrandedInventoryResponse }),
  });
}
